import {StyleSheet} from "aphrodite/no-important"
export const styles = StyleSheet.create({
                          content: {
                              display: "grid",
                          },
                          dashContainer: {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flex: "auto",
                              width: "100%",

                          }
                          })


// WEBPACK FOOTER //
// ./src/pages/TableauSponsorPageStyle.ts